import select2 from 'select2';
import Dropzone from 'dropzone';

Dropzone.autoDiscover = false;

App.ProductImage = (function () {
  var crops;
  var images;
  var masterImagePath;
  var masterDz;
  var extraDz;

  function initEdit() {
    crops = {};
    images = {
      extra: []
    }
    initDropzones();
    initSaveButton();
    initSocialSection();
    initCropLoadButton();
    $("select").select2();
  }

  function initDropzones() {
    masterDz = new Dropzone("#master-image", {
      sending: function(file, xhr) { $.rails.CSRFProtection(xhr); },
      thumbnailWidth: 225,
      thumbnailHeight: 225,
      thumbnailMethod: 'contain',
      dictDefaultMessage: "Drop the master transparent PNG here or click to upload.",
      previewTemplate: $("#dropzone-template").html(),
    });
    masterDz.on("success", function(file, data) {
      images.master = masterImagePath = data.path;
      // remove all but last image
      $("#master-image .dz-preview:not(:last)").each(function(index, e) {
        e.remove();
      });
      enableSaveButton();
    });

    masterImagePath = $("#master-image").data("image");
    if (masterImagePath != "") {
      images.master = masterImagePath;
      addExistingImageToDropzone(masterDz, masterImagePath);
    }

    extraDz = new Dropzone("#extra-images", {
      sending: function(file, xhr) { $.rails.CSRFProtection(xhr); },
      thumbnailWidth: 225,
      thumbnailHeight: 225,
      thumbnailMethod: 'contain',
      dictDefaultMessage: "Drop the extra product images here or click to upload.",
      previewTemplate: $("#dropzone-template").html(),
      addRemoveLinks: true
    });
    extraDz.on("success", function(file, data) {
      images.extra.push(data.path);
      enableSaveButton();
    });
    extraDz.on("removedfile", function(file) {
      if (file.path) {
        // remove it if it was an existing image
        var index = images.extra.indexOf(file.path);
        if (index >= 0) {
          images.extra.splice(index, 1);
        }
      }
      showRemovalNotice($(extraDz.element));
      enableSaveButton();
    });
    var extraImages = $("#extra-images").data("images");
    if (extraImages) {
      images.extra = extraImages;
      $.each(images.extra, function(index, path) {
        addExistingImageToDropzone(extraDz, path);
      });
    }

    var frontArtworkDz = new Dropzone("#front-artwork", {
      sending: function(file, xhr) { $.rails.CSRFProtection(xhr); },
      paramName: "front_artwork",
      thumbnailWidth: 225,
      thumbnailHeight: 225,
      thumbnailMethod: 'contain',
      dictDefaultMessage: "Drop the front artwork image here or click to upload.",
      previewTemplate: $("#dropzone-template").html(),
      addRemoveLinks: true
    });
    
    frontArtworkDz.on("success", function(file, data) {
      images.front_artwork = data.path;
      enableSaveButton();
    });

    frontArtworkDz.on("removedfile", function(file) {
      images.front_artwork = null;
      showRemovalNotice($(frontArtworkDz.element));
      enableSaveButton();
    });


    var designArtworkDz = new Dropzone("#design-artwork", {
      sending: function(file, xhr) { $.rails.CSRFProtection(xhr); },
      paramName: "design_artwork",
      thumbnailWidth: 225,
      thumbnailHeight: 225,
      thumbnailMethod: 'contain',
      dictDefaultMessage: "Drop the design artwork image here or click to upload.",
      previewTemplate: $("#dropzone-template").html(),
      addRemoveLinks: true
    });
  
    designArtworkDz.on("success", function(file, data) {
      images.design_artwork = data.path;
      console.log("Design artwork uploaded:", data.path);
      enableSaveButton();
    });

    designArtworkDz.on("removedfile", function(file) {
      images.design_artwork = null;
      showRemovalNotice($(designArtworkDz.element));
      enableSaveButton();
    });
  
  
    var backArtworkDz = new Dropzone("#back-artwork", {
      sending: function(file, xhr) { $.rails.CSRFProtection(xhr); },
      paramName: "back_artwork",
      thumbnailWidth: 225,
      thumbnailHeight: 225,
      thumbnailMethod: 'contain',
      dictDefaultMessage: "Drop the back artwork image here or click to upload.",
      previewTemplate: $("#dropzone-template").html(),
      addRemoveLinks: true
    });
  
    backArtworkDz.on("success", function(file, data) {
      images.back_artwork = data.path;
      enableSaveButton();
    });

    backArtworkDz.on("removedfile", function(file) {
      images.back_artwork = null;
      showRemovalNotice($(backArtworkDz.element));
      enableSaveButton();
    });


    // Initialize Left Sleeve Art dropzone
    var leftSleeveArtDz = new Dropzone("#left-sleeve-art", {
      sending: function(file, xhr) { $.rails.CSRFProtection(xhr); },
      paramName: "left_sleeve_art",
      thumbnailWidth: 225,
      thumbnailHeight: 225,
      thumbnailMethod: 'contain',
      dictDefaultMessage: "Drop the left sleeve art image here or click to upload.",
      previewTemplate: $("#dropzone-template").html(),
      addRemoveLinks: true
    });

    leftSleeveArtDz.on("success", function(file, data) {
      images.left_sleeve_art = data.path;
      enableSaveButton();
    });

    leftSleeveArtDz.on("removedfile", function(file) {
      images.left_sleeve_art = null;
      showRemovalNotice($(leftSleeveArtDz.element));
      enableSaveButton();
    });

    // Initialize Right Sleeve Art dropzone
    var rightSleeveArtDz = new Dropzone("#right-sleeve-art", {
      sending: function(file, xhr) { $.rails.CSRFProtection(xhr); },
      paramName: "right_sleeve_art",
      thumbnailWidth: 225,
      thumbnailHeight: 225,
      thumbnailMethod: 'contain',
      dictDefaultMessage: "Drop the right sleeve art image here or click to upload.",
      previewTemplate: $("#dropzone-template").html(),
      addRemoveLinks: true
    });

    rightSleeveArtDz.on("success", function(file, data) {
      images.right_sleeve_art = data.path;
      enableSaveButton();
    });

    rightSleeveArtDz.on("removedfile", function(file) {
      images.right_sleeve_art = null;
      showRemovalNotice($(rightSleeveArtDz.element));
      enableSaveButton();
    });

    // Load existing images if present
    var frontArtworkPath = $("#front-artwork").data("image");
    if (frontArtworkPath) {
      addExistingImageToDropzone(frontArtworkDz, frontArtworkPath);
    }

    var backArtworkPath = $("#back-artwork").data("image");
    if (backArtworkPath) {
      addExistingImageToDropzone(backArtworkDz, backArtworkPath);
    }
    
    var designArtworkPath = $("#design-artwork").data("image");
    if (designArtworkPath) {
      addExistingImageToDropzone(designArtworkDz, designArtworkPath);
    }

    // Load existing sleeve art images if present
    var leftSleeveArtPath = $("#left-sleeve-art").data("image");
    if (leftSleeveArtPath) {
      addExistingImageToDropzone(leftSleeveArtDz, leftSleeveArtPath);
    }

    var rightSleeveArtPath = $("#right-sleeve-art").data("image");
    if (rightSleeveArtPath) {
      addExistingImageToDropzone(rightSleeveArtDz, rightSleeveArtPath);
    }
  }

  function addExistingImageToDropzone(dz, path) {
    if (path == null || path === "") return;
    
    // Ensure we have a valid path before constructing the URL
    var url;
    if (path.startsWith('http')) {
      // If it's already a full URL, use it directly
      url = path;
    } else {
      // Otherwise, construct the S3 URL
      url = "https://s3.amazonaws.com/80stees-images/" + path;
    }
    
    var name = url.split("/").pop();
    var mockFile = { name: name, size: 0, path: path };
    dz.emit("addedfile", mockFile);
    dz.emit("thumbnail", mockFile, url);
    dz.emit("complete", mockFile);
  }

  function initSocialSection() {
    $("#edit-social-button").on("click", function(e) {
      e.preventDefault();
      enableSocialSection();
    });

    if ($("#social-section").data("enablesocial")) {
      enableSocialSection();
    }
  }

  function enableSocialSection() {
    $("#edit-social-button").hide();
    $("#social-section").show();
    initBgImageSelect();
    initTmImageSelect();
  }

  function initCropLoadButton() {
    $("#load-button").on("click", function(e) {
      e.preventDefault();
      initCrops();
    });
  }

  function initCrops() {
    var opts = {}
    
    // Only set masterimg if we have a valid path
    if (masterImagePath && masterImagePath.trim() !== "") {
      opts.masterimg = "https://s3.amazonaws.com/80stees-images/" + masterImagePath;
    } else {
      // If no master image path, show an error and return
      App.Alert.show("Please upload a master image first", 'alert');
      return;
    }
    
    var bgimg = $('select[name=bgimg]').val();
    if (bgimg) {
      var parts = bgimg.split("||");
      opts.fbbgimg = parts[0];
      opts.multibgimg = parts[1];
      opts.pinbgimg = opts.multibgimg;
      opts.storybgimg = opts.multibgimg;
    }

    opts.fblogo = $("input[name=fblogo]:checked").val();
    opts.multilogo = $("input[name=multilogo]:checked").val();
    opts.pinlogo = $("input[name=pinlogo]:checked").val();
    opts.storylogo = $("input[name=storylogo]:checked").val();

    var tmimgval = $('#tmImgSelect').val();
    if (tmimgval && tmimgval.trim() !== "") {
      // Get the full URL with transformations for the trademark logo
      opts.tmimg = 'https://s3.amazonaws.com/80stees-images/Logos/' + tmimgval + '?fit=fill&h=196&w=460&usm=15&bg=00354651&q=100';
    }
    opts.tmshadow = $("input[name=tmshadow]:checked").val();

    crops.col = initCrop({ type: 'col', width: 392, height: 600, opts: opts});
    crops.fb = initCrop({ type: 'fb', width: 840, height: 438.9, opts: opts});
    crops.multi = initCrop({ type: 'multi', width: 500, height: 500, opts: opts});
    crops.pin = initCrop({ type: 'pin', width: 300, height: 460, opts: opts});
    crops.story = initCrop({ type: 'story', width: 432, height: 768, opts: opts});
    crops.folded = initCrop({ type: 'folded', width: 392, height: 600, opts: opts});
    console.log('Crops initialized');

    $("#save-button").prop("disabled", true).text('Loading previews...');
    $("#save-folded-button").prop("disabled", true);
    $("#load-button").prop("disabled", true);

    var readyPromises = Object.keys(crops).map(function(type) {
      return crops[type].whenReady();
    });

    Promise.all(readyPromises).then(function() {
      $("#load-button").prop("disabled", false);
      enableSaveButton();
      $("#save-button").text('Save All Images');
      console.log('All crops ready');
    }).catch(function(err) {
      $("#load-button").prop("disabled", false);
      $("#save-button").text('Save All Images');
      crops = {};
      App.Alert.show(err.message || 'Failed to load social image previews. Check the browser console.', 'alert');
    });
  }

  function enableSaveButton() {
    $("#save-button").prop("disabled", false);
    $("#save-folded-button").prop("disabled", false);
  }

  function showRemovalNotice($dropzoneEl) {
    var $notice = $dropzoneEl.find('.js-removal-notice');
    if (!$notice.length) {
      $notice = $(
        '<p class="js-removal-notice callout warning" style="margin: 10px 12px 0; padding: 8px 12px; clear: both;">' +
        'Click Save All Images to finalize the removal of image(s).' +
        '</p>'
      );
      $dropzoneEl.append($notice);
    }
    $notice.show();
  }

  function initCrop(opts) {
    var container = $("#" + opts.type + "-canvas-container");
    container.html(
      '<canvas id="' + opts.type + '-canvas" width="' + opts.width + '" height="' + opts.height + '"></canvas>'
    );
    return App.ProductImageCrop.init(_.merge({canvasId: opts.type + '-canvas', type: opts.type}, opts.opts));
  }

  function initBgImageSelect() {
    var select = $('#bgImgSelect');
    $.get('https://sheets.googleapis.com/v4/spreadsheets/1WEB8tZ3N2QQmo1rGOVDIeNYdwWA-mP463xeLZ24LnTI/values/sheet1?key=AIzaSyAKW2SVf8xXEyqma-HR_GsxiLCAkoOpaFk', function(data) {
      $.each(data.values, function(index, e) {
        if (index > 0) { // skip header
          var desc = e[1];
          var url = e[0];
          var murl = e[5];
          var option = $('<option>', {
            value: url + '||' + murl,
            text : desc
          }).data('multiurl', murl);
          select.append(option);
        }
      });

      select.on("change", function() {
        var val = $(this).val() || "";
        if (val == "") {
          $("#fbbgImgPreview").html("");
          $("#multibgImgPreview").html("");
        } else {
          var parts = val.split("||");
          var url = parts[0];
          var multiurl = parts[1];
          $("#fbbgImgPreview").html("<img src=\"" + url + "&w=350&h=200&fit=crop&usm=18" + "\" />");
          $("#multibgImgPreview").html("<img src=\"" + multiurl + "&w=350&h=200&fit=crop&usm=18" + "\" />");
        }
      });
    });
  }

  function initTmImageSelect() {
    var select = $('#tmImgSelect');
    var tm = select.data("tm");
    
    // Check if selected trademark doesn't have a logo
    if (tm && select.find('option:selected').length === 0) {
      // Show warning to user
      select.after('<div class="callout warning mt10">No logo found for "' + tm + 
                   '". <a href="/s3_assets/new?asset_type=trademark_logo&name=' + 
                   encodeURIComponent(tm) + '" class="button tiny">Upload logo</a></div>');
    }
    
    // Continue with existing logo selection logic
    select.on('change', function() {
      var logoName = $(this).find('option:selected').text();
      if (logoName) {
        console.log("Selected trademark logo: " + logoName);
      }
    });
  }

  var UPLOAD_TIMEOUT_MS = 120000;

  function delay(ms) {
    return new Promise(function(resolve) { setTimeout(resolve, ms); });
  }

  function resetSaveAllButton(button) {
    button.prop('disabled', false).text('Save All Images');
  }

  function resetFoldedSaveButton(button) {
    button.prop('disabled', false).text('Save Folded Image');
  }

  function showSaveError(xhr, fallbackMessage) {
    if (xhr && xhr.status == 422) {
      var data = $.parseJSON(xhr.responseText);
      App.Alert.show("Error saving images: " + data.errors.join(', '), 'alert');
    } else if (xhr && xhr.statusText === 'timeout') {
      App.Alert.show('Upload timed out. Please try again.', 'alert');
    } else {
      App.Alert.show(fallbackMessage || ('An unknown error occurred' + (xhr ? ' - status: ' + xhr.status : '')), 'alert');
    }
  }

  function uploadBlob(uploadUrl, blob, fileName) {
    var fd = new FormData();
    fd.append('blob', blob);
    fd.append('file_name', fileName);
    return $.ajax({
      url: uploadUrl,
      type: 'POST',
      data: fd,
      processData: false,
      contentType: false,
      timeout: UPLOAD_TIMEOUT_MS,
      beforeSend: function(xhr) { $.rails.CSRFProtection(xhr); },
    });
  }

  function saveImagesPayload(saveUrl, extraParams) {
    var url = saveUrl;
    if (extraParams) {
      url += '?' + $.param(extraParams);
    }
    return $.ajax({
      url: url,
      type: 'POST',
      data: { images: images },
      timeout: UPLOAD_TIMEOUT_MS,
    });
  }

  function cropExportLabel(type) {
    return type.charAt(0).toUpperCase() + type.slice(1);
  }

  function exportCropBlob(crop, type) {
    if (!crop) {
      throw new Error('Social image "' + type + '" is not ready. Click Load and try again.');
    }
    if (!crop.isReady()) {
      throw new Error(cropExportLabel(type) + ' preview is still loading. Wait for previews to finish, then try again.');
    }
    try {
      if (type === 'folded') {
        return crop.getPngBlob();
      }
      return crop.getJpegBlob();
    } catch (err) {
      console.error('exportCropBlob failed for ' + type + ':', err);
      if (err && err.name === 'SecurityError') {
        throw new Error('Could not export ' + cropExportLabel(type) + ' image (browser blocked canvas export). Click Load again, or re-upload the master PNG.');
      }
      throw new Error('Could not export ' + cropExportLabel(type) + ' image. Try clicking Load again.');
    }
  }

  function prepareCropUploadJobs(cropTypes, button, sku) {
    var total = cropTypes.length;
    var jobs = [];

    return cropTypes.reduce(function(chain, type, index) {
      return chain.then(function() {
        button.text('Preparing ' + cropExportLabel(type) + ' (' + (index + 1) + ' of ' + total + ')...');
        return delay(0).then(function() {
          var isPng = type === 'folded';
          jobs.push({
            type: type,
            blob: exportCropBlob(crops[type], type),
            fileName: sku + '.' + type + (isPng ? '.png' : '.jpeg'),
          });
        });
      });
    }, Promise.resolve()).then(function() { return jobs; });
  }

  function uploadCropJobs(jobs, uploadUrl, button) {
    var remaining = jobs.length;
    button.text('Uploading images (' + remaining + ' remaining)...');

    return Promise.all(jobs.map(function(job) {
      return uploadBlob(uploadUrl, job.blob, job.fileName).then(function(data) {
        images[job.type] = data.path;
        remaining -= 1;
        button.text('Uploading images (' + remaining + ' remaining)...');
      });
    }));
  }

  function runSaveAllImages(button, uploadUrl, saveUrl, completeUrl, sku) {
    var cropTypes = Object.keys(crops || {});

    button.prop('disabled', true);

    var waitForCrops = cropTypes.length === 0
      ? Promise.resolve()
      : Promise.all(cropTypes.map(function(type) { return crops[type].whenReady(); }));

    var pipeline = waitForCrops.then(function() {
      if (cropTypes.length === 0) return;
      return prepareCropUploadJobs(cropTypes, button, sku)
        .then(function(jobs) { return uploadCropJobs(jobs, uploadUrl, button); });
    });

    return pipeline
      .then(function() {
        button.text('Saving...');
        return saveImagesPayload(saveUrl);
      })
      .then(function() {
        App.Alert.show('Images saved successfully.  Redirecting...', 'notice');
        document.location = completeUrl;
      });
  }

  function initSaveButton() {
    $("#save-button").on("click", function(e) {
      e.preventDefault();
      var button = $(this);
      var uploadUrl = button.data('uploadurl');
      var saveUrl = button.data('saveurl');
      var completeUrl = button.data('completeurl');
      var sku = button.data('sku');

      runSaveAllImages(button, uploadUrl, saveUrl, completeUrl, sku).catch(function(err) {
        console.error('Save all images failed:', err);
        if (err && err.message) {
          App.Alert.show(err.message, 'alert');
        } else if (err && err.statusText) {
          showSaveError(err, 'Failed to save images. Please try again.');
        } else {
          App.Alert.show('Failed to save images. Please try again.', 'alert');
        }
        resetSaveAllButton(button);
      });
    });

    $("#save-folded-button").on("click", function(e) {
      e.preventDefault();
      var button = $(this);
      var uploadUrl = button.data('uploadurl');
      var saveUrl = button.data('saveurl');
      var uploadType = button.data('uploadtype');
      var completeUrl = button.data('completeurl');
      var sku = button.data('sku');

      button.prop('disabled', true).text('Preparing folded image...');

      delay(0).then(function() {
        var blob = exportCropBlob(crops.folded, 'folded');
        button.text('Uploading folded image...');
        return uploadBlob(uploadUrl, blob, sku + '.folded.png');
      }).then(function(data) {
        images.folded = data.path;
        button.text('Saving...');
        return saveImagesPayload(saveUrl, { upload_type: uploadType });
      }).then(function() {
        App.Alert.show('Folded Image saved successfully.  Redirecting...', 'notice');
        document.location = completeUrl;
      }).catch(function(err) {
        console.error('Save folded image failed:', err);
        if (err && err.message) {
          App.Alert.show(err.message, 'alert');
        } else {
          showSaveError(err, 'Failed to save folded image. Please try again.');
        }
        resetFoldedSaveButton(button);
      });
    });
  }

  function debug() {
    return {
      images: images
    }
  }

  return {
    initEdit: initEdit,
    debug: debug
  }
})();
